import { XIcon } from "@/components/socialIcons";
import { GAME_NAME } from "@/config/game";
import { DISCORD_URL, INSTAGRAM_URL, TIKTOK_URL, X_URL } from "@/config/social";
import { useTranslation } from "@repo/shared/i18n";
import { useEffect } from "react";

import "./who-are-we.css";

const WhoAreWe = () => {
  const { t } = useTranslation("company");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className={"min-w-screen text-white max-w-[3840px] mx-auto"}>
      <div className="relative text-center">
        <img
          className="w-full mobile:h-[600px] h-[400px] opacity-50 xx-large:object-cover"
          alt={t("whoAreWe.hero.stadiumAlt")}
          src={
            import.meta.env.VITE_APP_ASSETS_BASE_URL +
            "/fut23/who-are-we/stadium.png"
          }
        />
        <div className="absolute flex flex-col items-center transform -translate-x-1/2 -translate-y-1/2 w-4/5 mobile:w-auto top-1/2 left-1/2 gap-y-10">
          <div className="mobile:text-5xl text-3xl font-black mobile:w-[600px] w-full">
            {t("whoAreWe.hero.title")}
          </div>
          <div className="mobile:text-xl text-base font-medium mobile:w-[700px] w-full text-center">
            {t("whoAreWe.hero.mission", { game: GAME_NAME })}
          </div>
        </div>
      </div>
      {/* Partners.. */}
      <div className="w-full text-black bg-white ">
        <div className="max-w-[1680px] mx-auto flex mobile:flex-row flex-col justify-between items-center gap-x-8">
          <div className="flex flex-col mobile:w-[600px] w-4/5 ml-10 mx-auto mt-20">
            <p className="mobile:text-5xl font-black text-3xl">
              {t("whoAreWe.partners.title")}
            </p>
            <p className="mobile:text-4xl font-extrabold">
              {t("whoAreWe.partners.subtitle")}
            </p>
            <p className="mt-4 mobile:text-xl font-medium text-base">
              {t("whoAreWe.partners.body")}
            </p>
            <div className="flex flex-row mx-auto mt-4 mb-10 mobile:gap-x-16 gap-x-10 desktop:pr-4">
              <a
                href={"https://twitter.com/SAF_gg"}
                target="_blank"
                rel="noreferrer"
                className="rounded-full"
              >
                <img
                  className="mobile:w-48 mobile:h-48 w-28 h-28 partners_logo"
                  src={
                    import.meta.env.VITE_APP_ASSETS_BASE_URL +
                    "/fut23/who-are-we/saf.png"
                  }
                  alt={t("whoAreWe.partners.safAlt")}
                />
              </a>
              <a
                href={"https://teamdux.com/"}
                target="_blank"
                rel="noreferrer"
                className="rounded-full"
              >
                <img
                  className="mobile:w-48 mobile:h-48 w-28 h-28 partners_logo"
                  src={
                    import.meta.env.VITE_APP_ASSETS_BASE_URL +
                    "/fut23/who-are-we/dux.png"
                  }
                  alt={t("whoAreWe.partners.duxAlt")}
                />
              </a>
            </div>
          </div>
          <img
            className="hidden mobile:block w-[500px] desktop:min-w-[400px] object-contain h-min bg-gray-300 my-auto mt-20 mobile:mb-20 mb-10 mr-20 desktop:mr-10"
            src={
              import.meta.env.VITE_APP_ASSETS_BASE_URL +
              "/fut23/who-are-we/saf-celebrating.png"
            }
            alt={t("whoAreWe.partners.safCelebratingAlt")}
          />
        </div>
      </div>
      <div className="max-w-[1680px] mx-auto text-white flex mobile:flex-row flex-col-reverse justify-between items-center gap-x-8 mt-20 mb-20">
        <img
          className="mobile:w-[500px] desktop:min-w-[400px] w-4/5 bg-gray-300 my-auto desktop:ml-10 mt-10 mobile:mt-0 mx-auto mobile:mx-0 object-contain"
          src={
            import.meta.env.VITE_APP_ASSETS_BASE_URL +
            "/fut23/who-are-we/for-the-players.png"
          }
          alt={t("whoAreWe.forThePlayers.imageAlt")}
        />
        <div className="flex flex-col large:w-[900px] ml-20 w-4/5 mobile:w-auto mr-20 desktop:mr-10 mx-auto mobile:mx-0 mobile:text-right text-left">
          <p className="mobile:text-5xl font-black text-3xl">
            {t("whoAreWe.forThePlayers.title")}
          </p>
          <p className="mt-8 font-medium mobile:text-xl text-base max-w-[600px] w-full mobile:w-auto ml-auto mx-auto mobile:mx-0 text-left">
            {t("whoAreWe.forThePlayers.body")}
          </p>
        </div>
      </div>
      <div className="w-full text-black bg-white">
        <div className="max-w-[1680px] mx-auto flex mobile:flex-row flex-col justify-between items-center gap-x-8 ">
          <div className="flex flex-col mobile:w-[600px] w-4/5 ml-10 mx-auto mt-20 mb-10">
            <p className="mobile:text-5xl font-black text-3xl">
              {t("whoAreWe.rules.title")}
            </p>
            <p className="mt-8 mobile:text-xl font-medium text-base text-left">
              {t("whoAreWe.rules.body1", { game: GAME_NAME })}
            </p>
            <p className="mt-2 mobile:text-xl font-medium text-base text-left">
              {t("whoAreWe.rules.body2")}
            </p>
          </div>
          <img
            className="mobile:w-[500px] desktop:min-w-[400px] ml-20 mobile:ml-0 w-4/5 bg-gray-300 my-auto mr-20 desktop:mr-10 mb-20 mx-auto object-contain h-min"
            src={
              import.meta.env.VITE_APP_ASSETS_BASE_URL +
              "/fut23/who-are-we/follow-rules.png"
            }
            alt={t("whoAreWe.rules.imageAlt")}
          />
        </div>
      </div>
      <div className="flex mobile:flex-row items-center justify-between w-full text-white flex-col-reverse">
        <div className="flex flex-col mobile:w-[600px] w-4/5 mx-auto mt-20">
          <p className="mobile:text-5xl font-black text-center text-3xl">
            {t("whoAreWe.knowMore.title")}
          </p>
          <p className="mt-8 mobile:text-xl font-medium mobile:text-center text-base text-left">
            {t("whoAreWe.knowMore.body")}
          </p>
        </div>
      </div>
      <div className="flex w-full mb-20">
        <div className="flex flex-row mx-auto mobile:mt-12 mobile:gap-x-12 gap-x-2 mt-8">
          <a
            href={DISCORD_URL}
            className="rounded-full"
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="mobile:w-32 mobile:h-32 w-16 h-16 social_logo"
              src={
                import.meta.env.VITE_APP_ASSETS_BASE_URL +
                "/fut23/who-are-we/discord.png"
              }
              alt={t("whoAreWe.social.discordAlt")}
            />
          </a>
          <a
            href={INSTAGRAM_URL}
            className="rounded-full"
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="mobile:w-32 mobile:h-32 w-16 h-16 social_logo"
              src={
                import.meta.env.VITE_APP_ASSETS_BASE_URL +
                "/fut23/who-are-we/instagram.png"
              }
              alt={t("whoAreWe.social.instagramAlt")}
            />
          </a>
          <a
            href={X_URL}
            className="rounded-full"
            target="_blank"
            rel="noreferrer"
            aria-label={t("whoAreWe.social.xAlt")}
          >
            {/* Drawn rather than an uploaded badge: X ships the bare glyph, and
                the black disc is its own badge treatment. */}
            <div className="mobile:w-32 mobile:h-32 w-16 h-16 social_logo flex items-center justify-center rounded-full bg-black">
              <XIcon className="mobile:h-14 h-7 w-auto text-white" />
            </div>
          </a>
          <a
            href={TIKTOK_URL}
            target="_blank"
            rel="noreferrer"
            className="rounded-full"
          >
            <img
              className="mobile:w-32 mobile:h-32 w-16 h-16 social_logo"
              alt={t("whoAreWe.social.tiktokAlt")}
              src={
                import.meta.env.VITE_APP_ASSETS_BASE_URL +
                "/fut23/who-are-we/_tiktok.png"
              }
            />
          </a>
        </div>
      </div>
    </main>
  );
};

export default WhoAreWe;
